export const ReceiptIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M1 4C1 2.34315 2.34315 1 4 1H20.5H18V23L13.9693 22.5521C13.6575 22.5175 13.3427 22.5197 13.0314 22.5586L9.5 23L5.46931 22.5521C5.15752 22.5175 4.84273 22.5197 4.53145 22.5586L1 23V4Z" />
        <path d="M23 6V3.5C23 2.11929 21.8807 1 20.5 1C19.1193 1 18 2.11929 18 3.5V6H23Z" />
        <path d="M5 10H14" />
        <path d="M5 15L11.5 15" />
      </g>
    </svg>
  );
};
